import { Injectable } from '@angular/core';
import { Http, RequestOptions, URLSearchParams, ResponseContentType, RequestMethod, Headers } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
// import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';

import * as moment from 'moment';

import {saveAs as importedSaveAs} from "file-saver";

import { environment } from './../../environments/environment';
import { Book } from '../models/Book';
import { Contributor } from '../models/Contributor';
import { Dewey } from '../models/Dewey';
import { Editore } from '../models/Editore';
import { Testata } from '../models/Testata';
import { Distributore } from '../models/Distributore';
import { Onix } from '../models/Onix';
import { ProductRelationship } from '../models/ProductRelationship';
import { Lingua } from '../models/Lingua';
import { Collana } from '../models/Collana';
import { Argomento } from '../models/Argomento';
import { Bisac } from '../models/Bisac';
import { Cce } from '../models/Cce';
import { Catalogazione } from '../models/Catalogazione';
import { ServizioStampa } from '../models/ServizioStampa';
import { StatusLog } from '../models/StatusLog';

import { SharedService } from './shared.service';


const accounting = require("accounting");

const textVersion = require("textversionjs");
// const Entities = require('html-entities').AllHtmlEntities;
const Entities = require('html-entities/lib/html5-entities');

const entities = new Entities();

const ONIX150 = {
  '00': 'Non definito',
  'AA': 'Audio',
  'AB': 'Cassetta audio',
  'AC': 'CD-Audio',
  'AD': 'DAT',
  'AE': 'Disco audio',
  'AF': 'Nastro audio',
  'AG': 'MiniDisc',
  'AH': 'CD-Extra',
  'AI': 'DVD Audio',
  'AJ': 'File audio per il download ',
  'AK': 'Lettore digitale portatile con brani pre-registrati',
  'AL': 'Scheda Secure Digital con brani pre-registrati',
  'AZ': 'Altro formato audio',
  'BA': 'Libro',
  'BB': 'Libro rilegato',
  'BC': 'Libro in brossura',
  'BD': 'Libro a fogli mobili',
  'BE': 'Libro spiralato',
  'BF': 'Opuscolo',
  'BG': 'Libro con legatura in pelle o di pregio',
  'BH': 'Cartonato',
  'BI': 'Libro in stoffa',
  'BJ': 'Libro da bagno',
  'BK': 'Libro novità',
  'BL': 'Fogli mobili con copertina in plastica',
  'BM': 'Libro di formato extra',
  'BN': 'Fascicolo',
  'BO': 'Libro o carta ripiegata',
  'BP': 'Libro in gommapiuma',
  'BZ': 'Libro di altro formato',
  'CA': 'Carta geografica',
  'CB': 'Carta geografica ripiegata',
  'CC': 'Carta geografica piana',
  'CD': 'Carta geografica arrotolata',
  'CE': 'Mappamondo',
  'CZ': 'Altro materiale cartografico',
  'DA': 'Materiale digitale (su supporto fisico)',
  'DB': 'CD-ROM',
  'DC': 'CD-I',
  'DE': 'Cartuccia gioco',
  'DF': 'Dischetto',
  'DI': 'DVD-ROM',
  'DJ': 'Scheda di memoria SD',
  'DK': 'Scheda di memoria Compact Flash',
  'DL': 'Scheda di memoria Memory Stick',
  'DM': 'USB Flash Drive',
  'DN': 'CD/DVD doppia faccia',
  'DZ': 'Altro dispositivo digitale',
  'EA': 'Contenuto digitale (fornito elettronicamente)',
  'EB': 'Contenuto digitale per download e accesso on line',
  'EC': 'Contenuto digitale per accesso on line',
  'ED': 'Contenuto digitale per download',
  'FA': 'Pellicola o diapositiva',
  'FC': 'Diapositive',
  'FD': 'Diapositive OHP',
  'FE': 'Filmina',
  'FF': 'Film',
  'FZ': 'Altro formato in pellicola o diapositiva',
  'LA': 'Licenza di prodotto digitale',
  'LB': 'Chiave di licenza di prodotto digitale',
  'LC': 'Codice di licenza di prodotto digitale',
  'MA': 'Microforma',
  'MB': 'Microfiche',
  'MC': 'Microfilm',
  'MZ': 'Altra microforma',
  'PA': 'Materiale a stampa miscellaneo',
  'PB': 'Rubrica',
  'PC': 'Calendario',
  'PD': 'Carte',
  'PE': 'Copia mastro',
  'PF': 'Diario',
  'PG': 'Fregio',
  'PH': 'Kit',
  'PI': 'Musica a stampa',
  'PJ': 'Libro o pacchetto di cartoline',
  'PK': 'Poster',
  'PL': 'Album di ricordi',
  'PM': 'Valigetta',
  'PN': 'Immagini o fotografie',
  'PO': 'Tabellone',
  'PP': 'Adesivi',
  'PQ': 'Tavola illustrata',
  'PR': 'Taccuino',
  'PS': 'Organizer',
  'PT': 'Segnalibro',
  'PZ': 'Altro materiale a stampa',
  'SA': 'Prodotto composito per vendita al dettaglio',
  'SB': 'Prodotto composito per vendita al dettaglio, in scatola',
  'SC': 'Prodotto composito per vendita al dettaglio, cofanetto',
  'SD': 'Prodotto composito per vendita al dettaglio, incellofanato',
  'SE': 'Prodotto composito per vendita al dettaglio, sfuso',
  'SF': 'Prodotto composito per vendita al dettaglio, parti incluse',
  'VA': 'Video ',
  'VF': 'Videodisco',
  'VI': 'DVD video',
  'VJ': 'VHS',
  'VK': 'Videocassetta Betamax ',
  'VL': 'VCD',
  'VM': 'SVCD',
  'VN': 'HD DVD',
  'VO': 'Blu-ray',
  'VP': 'Video UMD',
  'VQ': 'CBHD',
  'VZ': 'Altro formato video',
  'XA': 'Materiale per la distribuzione',
  'XB': 'Cesto vuoto',
  'XC': 'Cesto pieno',
  'XD': 'Espositore vuoto',
  'XE': 'Espositore pieno',
  'XF': 'Poster promozionale',
  'XG': 'Striscia copri scaffale',
  'XH': 'Vetrofania',
  'XI': 'Festone',
  'XJ': 'Espositore girevole',
  'XK': 'Libro in formato gigante',
  'XL': 'Pacco incellofanato',
  'XZ': 'Altro materiale per il punto vendita',
  'ZA': 'Prodotti vari',
  'ZB': 'Bambola',
  'ZC': 'Giocattolo morbido',
  'ZD': 'Giocattolo',
  'ZE': 'Gioco',
  'ZF': 'T-shirt',
  'ZG': 'Lettore di e-book',
  'ZH': 'Tablet',
  'ZZ': 'Altri prodotti'
}

const ONIX175 = {
  'A101': 'CD audio standard',
  'A102': 'SACD super audio ',
  'A103': 'MP3',
  'A104': 'WAV',
  'A105': 'Real Audio',
  'A106': 'WMA',
  'A107': 'AAC',
  'A108': 'Ogg/Vorbis',
  'A109': 'Audible',
  'A110': 'FLAC',
  'A111': 'AIFF',
  'A112': 'ALAC',
  'A201': 'DAISY 2: audio completo con soli titoli (senza navigazione)',
  'A202': 'DAISY 2: audio completo con navigazione (senza testo)',
  'A203': 'DAISY 2: audio completo con navigazione e testo parziale',
  'A204': 'DAISY 2: audio completo con navigazione e testo completo',
  'A205': 'DAISY 2: testo completo con navigazione e audio parziale',
  'A206': 'DAISY 2: testo completo con navigazione (senza audio)',
  'A207': 'DAISY 3: audio completo con soli titoli (senza navigazione)',
  'A208': 'DAISY 3: audio completo con navigazione (senza testo)',
  'A209': 'DAISY 3: audio completo con navigazione e testo parziale',
  'A210': 'DAISY 3: audio completo con navigazione e testo completo',
  'A211': 'DAISY 3: testo completo con navigazione e audio parziale',
  'A212': 'DAISY 3: testo completo con navigazione (senza audio)',
  'A301': 'Audio indipendente',
  'A302': '"Leggi con me"',
  'A303': '"Canta con me"',
  'A304': '"Parla con me"',
  'B101': 'Mass market (rack) paperback',
  'B102': 'Trade paperback (USA)',
  'B103': 'Digest format paperback (USA)',
  'B104': 'A-format paperback (UK)',
  'B105': 'B-format paperback (UK)',
  'B106': 'Trade paperback (UK)',
  'B107': 'Tall rack paperback (USA)',
  'B108': 'Tankobon formato A5',
  'B109': 'Tankobon formato B5 (JIS)',
  'B110': 'Tankobon formato B6 (JIS)',
  'B111': 'Bunko formato A6',
  'B112': 'Shinso B40-dori',
  'B113': 'Pocket (Svezia)',
  'B114': 'Storpocket (Svezia)',
  'B115': 'Kartonnage (Svezia)',
  'B116': 'Flexband (Svezia)',
  'B117': 'Mook',
  'B118': 'Dwarsligger',
  'B119': 'Formato 46',
  'B120': 'Henkei formato 46',
  'B121': 'A4',
  'B122': 'Henkei formato A4',
  'B123': 'Henkei formato A5',
  'B124': 'Henkei formato B5',
  'B125': 'Henkei formato B6',
  'B126': 'Formato AB',
  'B127': 'Formato B7 (JIS)',
  'B128': 'Formato Kiku',
  'B129': 'Formato Kiku-Henkei',
  'B130': 'Formato B4 (JIS)',
  'B131': 'Paperback (Germania)',
  'B201': 'Libro da colorare o con i puntini da unire',
  'B202': 'Libri con linguette da sollevare',
  'B204': 'Libro in miniatura',
  'B205': 'Libro con immagini in movimento',
  'B206': 'Libro pop-up',
  'B207': 'Libro profumato/odoroso',
  'B208': 'Libro con rumori e suoni',
  'B209': 'Libro con adesivi',
  'B210': 'Libro tattile',
  'B212': 'Libro fustellato',
  'B213': 'Libro-gioco',
  'B214': 'Libro con copertina morbida',
  'B215': 'Libro puzzle in feltro',
  'B221': 'Libro di disegni',
  'B222': 'Libro "carosello"',
  'B301': 'Prodotto a fogli mobili - Fogli e legatura',
  'B302': 'Prodotto a fogli mobili - Sola legatura',
  'B303': 'Prodotto a fogli mobili - Soli fogli',
  'B304': 'Legatura cucita',
  'B305': 'Legatura non cucita / con adesivo',
  'B306': 'Legatura per biblioteche',
  'B307': 'Legatura rinforzata',
  'B308': 'Mezza legatura',
  'B309': 'Quarto di legatura',
  'B310': 'Legatura cucita a sella',
  'B311': 'Legatura a pettine',
  'B312': 'Legatura a spirale Wire-O',
  'B313': 'Legatura a spirale coperta',
  'B401': 'Copertina in tessuto',
  'B402': 'Copertina in carta',
  'B403': 'Copertina in vera pelle',
  'B404': 'Copertina in finta pelle',
  'B405': 'Copertina in cuoio cucito',
  'B406': 'Pergamena',
  'B409': 'Tessuto',
  'B410': 'Simil-tessuto',
  'B411': 'Velluto',
  'B412': 'Copertina in plastica flessibile o vinile',
  'B413': 'Copertina in plastica  ',
  'B414': 'Copertina in vinile',
  'B415': 'Copertina laminata',
  'B501': 'Con sovraccoperta',
  'B502': 'Con sovraccoperta stampata',
  'B503': 'Con sovraccoperta trasparente',
  'B504': 'Con risvolti di copertina',
  'B505': 'Con indici laterali',
  'B506': 'Con nastri segnalibro',
  'B507': 'Con chiusura lampo',
  'B508': 'Con chiusura a bottone',
  'B509': 'Copertina in cuoio con risvolti larghi',
  'B510': 'Non rifilato',
  'B511': 'Con pagine apribili',
  'B601': 'Libro capovolto',
  'B602': 'Formato Manga originale ',
  'B701': 'Braille non contratto (Regno Unito)',
  'B702': 'Braille contratto (Regno Unito)',
  'B703': 'Braille (USA)',
  'B704': 'Braille non contratto (USA)',
  'B705': 'Braille contratto (USA)',
  'B706': 'Braille inglese unificato',
  'B707': 'Moon',
  'D101': 'Real Video',
  'D102': 'Quicktime',
  'D103': 'AVI',
  'D104': 'Windows Media Video',
  'D105': 'MPEG-4',
  'D201': 'MS-DOS',
  'D202': 'Windows',
  'D203': 'Macintosh',
  'D204': 'UNIX / LINUX',
  'D205': 'Altri sistemi operativi',
  'D206': 'Palm OS',
  'D207': 'Windows Mobile',
  'D301': 'Microsoft XBox',
  'D302': 'Nintendo Gameboy Color',
  'D303': 'Nintendo Gameboy Advanced',
  'D304': 'Nintendo Gameboy',
  'D305': 'Nintendo Gamecube',
  'D306': 'Nintendo 64',
  'D307': 'Sega Dreamcast',
  'D308': 'Sega Genesis/Megadrive',
  'D309': 'Sega Saturn',
  'D310': 'Sony Playstation 1',
  'D311': 'Sony Playstation 2',
  'D312': 'Nintendo Dual Screen',
  'D313': 'Sony PlayStation 3',
  'D314': 'Xbox 360',
  'D315': 'Nintendo Wii',
  'D316': 'Sony PlayStation Portable (PSP)',
  'E100': 'Altro tipo  ',
  'E101': 'EPUB',
  'E102': 'OEB',
  'E103': 'DOC',
  'E104': 'DOCX',
  'E105': 'HTML',
  'E106': 'ODF',
  'E107': 'PDF',
  'E108': 'PDF/A',
  'E109': 'RTF',
  'E110': 'SGML',
  'E111': 'TCR',
  'E112': 'TXT',
  'E113': 'XHTML',
  'E114': 'zTXT',
  'E115': 'XPS',
  'E116': 'Amazon Kindle',
  'E117': 'BBeB',
  'E118': 'DXReader',
  'E119': 'EBL',
  'E120': 'Ebrary',
  'E121': 'eReader',
  'E122': 'Exebook',
  'E123': 'Franklin eBookman',
  'E124': 'Gemstar Rocketbook',
  'E125': 'iSilo',
  'E126': 'Microsoft Reader',
  'E127': 'Mobipocket',
  'E128': 'MyiLibrary',
  'E129': 'NetLibrary',
  'E130': 'Plucker',
  'E131': 'VitalBook',
  'E132': 'Vook',
  'E133': 'Google Edition',
  'E134': 'App di lettura per iOS',
  'E135': 'App di lettura per Android',
  'E136': 'App di lettura per altri sistemi operativi',
  'E139': 'CEB',
  'E140': 'CEBX',
  'E141': 'iBook',
  'E142': 'ePIB',
  'E143': 'SCORM',
  'E144': 'EBP',
  'E200': 'Formato con reimpaginazione automatica (reflowable)',
  'E201': 'Formato fisso',
  'E202': 'Leggibile senza connessione di rete',
  'E203': 'Richiede connessione di rete',
  'E204': 'Contenuto rimosso',
  'E210': 'Orizzontale',
  'E211': 'Verticale',
  'E221': '5:4',
  'E222': '4:3',
  'E223': '3:2',
  'E224': '16:10',
  'E225': '16:9',
  'L101': 'Laminato',
  'P101': 'Calendario da tavolo',
  'P102': 'Mini calendario',
  'P103': 'Calendario degli appuntamenti',
  'P104': 'Calendario quotidiano',
  'P105': 'Poster calendario',
  'P106': 'Calendario da muro',
  'P107': 'Calendario perpetuo',
  'P108': 'Calendario dell\'Avvento',
  'P109': 'Calendario segnapagina',
  'P110': 'Calendario dello studente',
  'P111': 'Calendario di progetto',
  'P112': 'Almanacco',
  'P113': 'Altro tipo di calendario',
  'P114': 'Altro tipo di calendario o organizer',
  'P201': 'Rilegato (cancelleria)',
  'P202': 'Brossura (cancelleria)',
  'P203': 'Rilegato con spirale (cancelleria)',
  'P204': 'Rilegato in pelle / rilegatura di pregio (cancelleria)',
  'V201': 'PAL',
  'V202': 'NTSC',
  'V203': 'SECAM'
}

@Injectable()
export class BookService {

  selectedEAN: string;

  get selected(): string {
    return this.selectedEAN;
  }
  set selected(ean: string) {
    this.selectedEAN = ean;
  }

  constructor(public sharedService: SharedService, private http: Http) { }

  html2txt(html: string) {
    return html ? entities.decode(textVersion(html)) : undefined;
  }

  getBookCoverPath(ean13: string) {
    // console.log('getBook', ean13)

    // return environment.server.url + '/static/media/covers/' + environment.publisher + '/' + ean13 + '.jpg' + '?random=' + Math.random();
    return environment.server.url + '/static/media/covers/' + environment.publisher + '/' + ean13 + '.jpg' + '?random=' + Math.random();
  }

  persist(wmodel: any) {
    console.log('persist', wmodel)
    return this.http.post(environment.server.url + '/book/persist', { wmodel: wmodel })
      .map(response => {
        let r = response.json();
        console.log('persist', r)
        if (r.success) {
          console.log('persist - emit', r.result.value)
          this.sharedService.sharedEmitter.emit(r.result.value)
        }
        return r;
      })
      .catch((err) => Observable.throw(err))
  }

  updateServizioStampa(o: any) {
    if (o.descrizione) {
      o.descrizione.testo = this.html2txt(o.descrizione.testoFormattato);
    }
    if (o.sommario) {
      o.sommario.testo = this.html2txt(o.sommario.testoFormattato);
    }
    if (o.noteautore) {
      o.noteautore.testo = this.html2txt(o.noteautore.testoFormattato);
    }
    console.log('updateServizioStampa', o)
    return this.http.post(environment.server.url + '/book/updateServizioStampa', {
      ean13: o.ean13,
      descrizione: o.descrizione,
      sommario: o.sommario,
      noteautore: o.noteautore
    }).map(response => {
      let r = response.json();
      console.log('updateServizioStampa', r)
      if (r.success) {
        console.log('updateServizioStampa - emit', r.value)
        this.sharedService.sharedEmitter.emit(r.value)
      }
      return r;
    })
      .catch((err) => {
        console.log(err)
        Observable.throw(err);
        return err;
      })
  }

  getBook(ean13: string) {
    console.log('getBook', ean13)
    return this.http.post(environment.server.url + '/book/find-one', { ean13: ean13 })
      .map(response => response.json())
  }

  getPrezzoFromEdiwinExport(ean13: string) {
    console.log('getPrezzoFromEdiwinExport', ean13)
    return this.http.post(environment.server.url + '/book/getPrezzoFromEdiwinExport', { ean13: ean13 })
      .map(response => response.json())
  }

  search(opt) {
    console.log(opt)
    return this.http.post(environment.server.url + '/book/search', opt)
      .map(response => response.json())
      .catch(this.handleError)
  }

  getBookFromEdigita(ean13: string) {
    return this.http.post(environment.server.url + '/book/bookFromEdigita', { ean13: ean13 })
      .map(response => response.json())
      .catch(this.handleError)
  }

  getPdfFromEdigita(ean13: string) {
    return this.http.post(environment.server.url + '/book/pdfFromEdigita', { ean13: ean13 })
      .map(response => response.json())
      .catch(this.handleError)
  }

  downloadFile(wq) {
    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.post(environment.server.url + '/book/download', { filter: wq, download: true }, options)
      .map(response => {
        let fileBlob = response.blob();
        let blob = new Blob([fileBlob], {
          type: 'application/vnd.ms-excel'
        })
        return blob;
      })
      .catch(this.handleError)
  }

  downloadFullXlxs() {
    console.log('===== downloadFullXlxs =====')
    console.log(environment.server.url + '/catalogo/exportFullXlsx')
    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.post(environment.server.url + '/catalogo/exportFullXlsx', { }, options)
      .map(response => {
        let fileBlob = response.blob();
        let blob = new Blob([fileBlob], {
          type: 'application/vnd.ms-excel'
        })
        return blob;
      })
      .catch(this.handleError)
  }

  createCSVExportRL() {
    let options = new RequestOptions({ responseType: ResponseContentType.Blob });
    return this.http.post(environment.server.url + '/book/createCSVExportRL', {}, options)
      .map(response => {
        let fileBlob = response.blob();
        let blob = new Blob([fileBlob], {
          // type: 'application/csv'
          type: 'application/zip'
        })
        return blob;
      })
      .catch(this.handleError)
  }

  callSitoEndpointEvo(ean13: string):any {
    console.log('================== callsitoEndpointEvo **** : ', ean13, environment.server.url + '/book/find-evo');
    return this.http.post(environment.server.url + '/book/find-evo', { ean13: ean13 })
      .pipe(
        switchMap(
          (book: any) => {
            let payload = { book: book, ean13: ean13, marietti: environment.publisher == 'marietti' };
            console.log('================== callSitoEndpointEvo payload xxx xxx xxx ==================')
            console.log(payload)
            console.log('================== callSitoEndpointEvo payload xxx xxx xxx ==================')


            var headers = new Headers();
                headers.append('Access-Control-Allow-Origin' , '*');
                headers.append('Access-Control-Allow-Methods', 'GET, POST, PATCH, PUT, DELETE, OPTIONS');
                headers.append('Access-Control-Allow-Headers', 'Origin, Content-Type, X-Auth-Token');
                headers.append('Accept','*/*');
                headers.append('content-type','application/json');



            let options = new RequestOptions({
              headers: headers,
              responseType: ResponseContentType.Json,
              method: 'POST'
            })

            // return this.http.post(environment.syncUrlPortale, payload)
            return this.http.post(environment.syncUrlPortale, payload, options)
          }
        )
      ).map(response => response.json())
      .catch(this.handleError)
  }

  callSitoEndpoint(ean13: string) {
    console.log('================== callsitoEndpoint: ', ean13);
    return this.http.post(environment.syncUrlPortale, { ean13: ean13, marietti: environment.publisher == 'marietti' })
      .map(response => response.json())
      .catch(this.handleError)
  }

  updateWebSiteLink(ean13: string, slug: string) {
    console.log('================== updateWebSiteLink: ', ean13, slug);
    return this.http.post(environment.server.url + '/book/updateWebSiteLink', { ean13: ean13, slug: slug })
      .map(response => response.json())
      .catch(this.handleError)
  }

  callSitoImportCoversEndpoint(eans: string[]) {
    let body = JSON.stringify(eans);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json', 'Accept': 'q=0.8;application/json;q=0.9' });
    let options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Json,
      method: 'POST'
    })

    let usp = new URLSearchParams();
    usp.append('eans', body);

    console.log('================== callSitoImportCoversEndpoint xxxx: ', eans, body, options, environment.syncCoversPortale);
    let pippo = ['eans'];
    return this.http.post(environment.syncCoversPortale, usp)
      .map(response => response.json())
      .catch(this.handleError)
  }

  readIndiceTematico(parent?: string): Observable<any> {
    let q = parent ? { parent: parent } : {};
    return this.http.post(environment.server.url + '/book/indiceTematico', q)
      .map(response => response.json())
  }

  readIndiceGeografico(parent?: string): Observable<any> {
    let q = parent ? { parent: parent } : {};
    return this.http.post(environment.server.url + '/book/indiceGeografico', q)
      .map(response => response.json())
  }

  readDewey(q: any): Observable<any> {
    return this.http.post(environment.server.url + '/book/dewey', q)
      .map(response => response.json())
  }

  readEditore(): Observable<any> {
    return this.http.post(environment.server.url + '/book/editore', {})
      .map(response => response.json())
  }

  readDistributore(): Observable<any> {
    return this.http.post(environment.server.url + '/book/distributore', {})
      .map(response => response.json())
  }

  readCollane(): Observable<any> {
    return this.http.post(environment.server.url + '/book/collane', {})
      .map(response => response.json())
  }

  readTestate(): Observable<any> {
    return this.http.post(environment.server.url + '/book/testate', {})
      .map(response => response.json())
  }

  readOnix(list: string): Observable<any> {
    return this.http.post(environment.server.url + '/book/onix', { list: list })
      .map(response => response.json())
  }

  readTax(): Observable<any> {
    return Observable.of({
      success: true,
      items: [
        {
          value: '04',
          etichetta: '04'
        }, {
          value: '10',
          etichetta: '10'
        }, {
          value: '20',
          etichetta: '20'
        },
        {
          value: '65',
          etichetta: '65-ES.IVA ART.5-C.1-DM 9.'
        },
        {
          value: 'NS',
          etichetta: 'IVA assolta dall\'editore ART 74, 1C'
        }
      ]
    })
  }

  readPackaging(): Observable<any> {
    return this.http.post(environment.server.url + '/book/packaging', {})
      .map(response => response.json())
  }

  readArgomenti(): Observable<any> {
    return this.http.post(environment.server.url + '/book/argomenti', {})
      .map(response => response.json())
  }

  readAudience(): Observable<any> {
    return this.http.post(environment.server.url + '/book/audience', {})
      .map(response => response.json())
  }

  getCatalogoRow(o: any): any {
    let wmap = {};
    let book: Book = this.fromMongo(o);
    if (book.autoriabbreviatoedb) {
      let curatela = false;
      let wautoriDef = '';
      book.autoriabbreviatoedb.split(';').forEach(function(autore, i) {
        autore = autore.trim();
        if (autore != '') {
          if (autore.indexOf('(cur.)') != -1) {
            curatela = true;
          }
          autore = autore.replace(';', '').replace(' (aut.)', '').replace(' (cur.)', '').replace('()', '').replace('', '')
          wautoriDef += (i > 0 ? ' - ' : '') + autore;
        }
      })
      if (curatela) {
        wautoriDef += ' (a cura di)';
      }
      wmap['autori'] = wautoriDef;
    }

    let prefisso = '';
    let titolo = '';
    if (book.titolo) {
      prefisso = book.prefisso ? ' (' + book.prefisso + ')' : '';
      titolo = ' ' + book.titolo + prefisso;
    }
    wmap['titolo'] = titolo;

    let sottotitolo = '';
    let sottotitolo2 = '';
    if (book.titolo) {
      sottotitolo = book.sottotitolo ? '. ' + book.sottotitolo : '';
      sottotitolo2 = book.sottotitolo2 ? '. ' + book.sottotitolo2 : '';
    }
    wmap['sottotitolo'] = sottotitolo + sottotitolo2;


    let anno = '';
    let numVari = book.numristampa ? book.numristampa.toString() : '0';
    if (book.dtultimaristampa && book.dtpubblicazione) {
      // let anno1ed = ', [' + book.dtpubblicazione.toString().substring(0, 4) + ']';
      // let annoristampa = ', ' + ((numVari != '0' && numVari != '1') ? '<sup>' + numVari + '</sup>' : '') + book.dtultimaristampa.toString().substring(0, 4);

      let anno1ed = ', [' + (new Date(book.dtpubblicazione)).getFullYear() + ']';
      let annoristampa = ', ' + ((numVari != '0' && numVari != '1') ? '<sup>' + numVari + '</sup>' : '') + (new Date(book.dtultimaristampa)).getFullYear();

      anno += anno1ed + annoristampa;
    } else if (book.dtpubblicazione) {
      // anno = ', ' + book.dtpubblicazione.toString().substring(0, 4);
      anno = ', ' + (new Date(book.dtpubblicazione)).getFullYear();
    }
    if (book.dtultimaristampa
      && book.dtpubblicazione
      && book.dtultimaristampa.toString().substring(0, 4) == book.dtpubblicazione.toString().substring(0, 4)) {
      // wmap['anno'] = ', ' + book.dtpubblicazione.toString().substring(0, 4);
      wmap['anno'] = ', ' + (new Date(book.dtpubblicazione)).getFullYear();
    }
    else {
      wmap['anno'] = anno;
    }


    let pagine = '';
    if (book.pagcomplessive && book.pagcomplessive != 0) {
      pagine = ', pp. ' + book.pagcomplessive;
    }
    wmap['pagine'] = pagine;


    let confezione = '';
    if (book.confezione) {
      confezione = ', ' + (book.numinconfezione && book.numinconfezione != '0' && book.numinconfezione != '1' ? book.numinconfezione + ' ' : '') + book.confezione.etichetta;
    } else {
      confezione = '';
    }
    wmap['confezione'] = confezione;


    let prezzo = ''
    if (book.prezzo && book.prezzo != 0) {
      prezzo = accounting.formatMoney(book.prezzo, ", € ", 2, ".", ",");
    } else {
      prezzo = '';
    }
    wmap['prezzo'] = prezzo;


    wmap['codice'] = book.ean13 ? (", cod. " + book.ean13.substring(7, 12) + "~" + book.ean13.substring(12)) : '';


    return wmap;
  }

  fromMongo(o: any): Book {
    let book: Book = new Book();
    let onix3 = o.onix3;

    // ===== EAN-13 ======
    book.ean13 = o.ean13;

    if (onix3.RecordReference) {
      book.idtitolo = onix3.RecordReference.replace('CEDCatalog.onix301.', '');
    }

    // ===== EDITORE ======
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.Publisher) {
        let we = onix3.PublishingDetail.Publisher.find(p => p.PublishingRole == '01');
        if (we) {
          book.editore = new Editore({
            codice: we.PublisherIdentifier ? we.PublisherIdentifier.IDValue : undefined,
            descrizione: we.PublisherName
          })
          if(we.Website) {
            book.websiteLink = we.Website.WebsiteLink;
          }
        }
      }
    }

    // ===== CO-EDITORE ======
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.Publisher) {
        let we = onix3.PublishingDetail.Publisher.find(p => p.PublishingRole == '02');
        if (we) {
          book.coeditore = new Editore({
            codice: we.PublisherIdentifier ? we.PublisherIdentifier.IDValue : undefined,
            descrizione: we.PublisherName
          })
        }
      }
    }

    // ===== MARCHIO EDITORIALE ======
    if (onix3.PublishingDetail) {
      let imprint = onix3.PublishingDetail.Imprint;
      if (imprint) {
        book.marchio = new Editore({
          codice: imprint.ImprintIdentifier ? imprint.ImprintIdentifier.IDValue : undefined,
          descrizione: imprint.ImprintName
        })
      }
    }

    // ===== LUOGO DI PUBBLICAZIONE ======
    if (onix3.PublishingDetail) {
      book.cityOfPublication = onix3.PublishingDetail.CityOfPublication;
    }

    // ===== CONTRIBUTORS ======
    if (onix3.DescriptiveDetail) {
      book.contributor = [];
      if (onix3.DescriptiveDetail.Contributor) {
        let wa = o.autoriabbreviatoedb ? o.autoriabbreviatoedb.split(';') : [];
        onix3.DescriptiveDetail.Contributor.forEach(c => {

          let xz = c.KeyNames ? c.KeyNames + ' ' + c.NamesBeforeKey : c.NamesBeforeKey;
          // let z = wa.find(a => a.indexOf(c.KeyNames + ' ' + c.NamesBeforeKey) != -1);
          let z = wa.find(a => a.indexOf(xz) != -1);
          let boh = z ? true : false;
          // console.log('OCCCCCCHIO')
          book.contributor.push(
            new Contributor({
              ruolo: new Onix({ value: c.ContributorRole }),
              codice: c.NameIdentifier.IDValue,
              nomecompleto: c.PersonName,
              cognome: c.KeyNames,
              nome: c.NamesBeforeKey,
              boh: boh
            }))
        })
      }
    }
    book.autoriabbreviato = o.autoriabbreviato;
    book.autoriabbreviatoedb = o.autoriabbreviatoedb;
    book.autoriportale = o.autoriportale;


    // ===== TITOLO  ======
    if (onix3.DescriptiveDetail) {
      let titleDetail = onix3.DescriptiveDetail.TitleDetail;
      if (titleDetail) {
        let wo = titleDetail.find(p => p.TitleType == '01');
        if (wo) {
          let wte = wo.TitleElement;
          if (wte && wte.TitleElementLevel == '01') {
            book.prefisso = wte.TitlePrefix;
            book.titolo = wte.TitleWithoutPrefix ? wte.TitleWithoutPrefix : wte.TitleText;
            book.sottotitolo = wte.Subtitle;
          }
        }

        wo = titleDetail.find(p => p.TitleType == '03');
        if (wo) {
          let wte = wo.TitleElement;
          if (wte) {
            book.titolooriginale = wte.TitleText;
          }
        }

        wo = titleDetail.find(p => p.TitleType == '05');
        if (wo) {
          let wte = wo.TitleElement;
          if (wte) {
            book.titolobreve = wte.TitleText;
          }
        }
      }
    }
    book.sottotitolo2 = o.sottotitolo2;
    book.titoloEDB = o.titoloEDB

    if (onix3.DescriptiveDetail) {
      let collection = onix3.DescriptiveDetail.Collection;
      if (collection) {
        let wo = collection.find(p => p.CollectionType == '00');
        if (wo) {
          let wtd = wo.TitleDetail;
          if (wtd && wtd.TitleType == '01') {
            let titleElement = wtd.TitleElement;
            let wte = titleElement.find(p => p.TitleElementLevel == '02');
            if (wte) {
              book.insiemetitolo = wte.TitleText;
              book.insiemeparte = wte.PartNumber;
            }
            let wts = titleElement.find(p => p.TitleElementLevel == '03');
            if (wts) {
              book.sottoinsiemetitolo = wts.TitleText;
              book.sottoinsiemeparte = wts.PartNumber;
            }
          }
        }
      }
    }

    // ===== NOTE COMMENTO ======
    book.notecommento = o.notecommento;

    book.visibile = o.visibile;

    book.carrellabile =  o.carrellabile;

    // ===== TIPO EDIZIONE ======
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.EditionType) {
        book.edizione = new Onix({ value: onix3.DescriptiveDetail.EditionType });
      }
    }

    // ===== NUMERO EDIZIONE ======
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.EditionNumber) {
        book.numedizione = +onix3.DescriptiveDetail.EditionNumber;
      }
    }

    // ===== NUMERO RISTAMPA ======
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.LatestReprintNumber) {
        book.numristampa = +onix3.PublishingDetail.LatestReprintNumber;
      }
    }

    // ===== COLLEGAMENTO ALTRE OPERE =====
    if (onix3.RelatedMaterial) {
      if (onix3.RelatedMaterial.RelatedProduct) {
        onix3.RelatedMaterial.RelatedProduct.forEach(o => {
          book.relatedProducts.push(new ProductRelationship({
            tipologia: new Onix({ value: o.ProductRelationCode }),
            ean13: o.ProductIdentifier ? o.ProductIdentifier.IDValue : undefined
          }))
        })
      }
    }

    // ===== TIPO PRODOTTO =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.ProductForm) {
        book.tipoProdotto = new Onix({ value: onix3.DescriptiveDetail.ProductForm, etichetta: ONIX150[onix3.DescriptiveDetail.ProductForm] });
      }
    }

    // ===== TIPO PRODOTTO DETTAGLIO =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.ProductFormDetail) {
        book.tipoProdottoDettaglio = new Onix({ value: onix3.DescriptiveDetail.ProductFormDetail, etichetta: ONIX175[onix3.DescriptiveDetail.ProductFormDetail] });
      }
    }

    // ===== STAGIONALITA =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.ReligiousText) {
        if (onix3.DescriptiveDetail.ReligiousText.ReligiousTextFeature) {
          onix3.DescriptiveDetail.ReligiousText.ReligiousTextFeature.forEach(o => {
            book.stagionalita.push(new Onix({ value: o.ReligiousTextFeatureCode }))
          })
        }
      }
    }

    // ===== LINGUE =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Language) {
        onix3.DescriptiveDetail.Language.forEach(o => {
          book.lingue.push(new Lingua({
            tipologia: new Onix({ value: o.LanguageRole }),
            lingua: new Onix({ value: o.LanguageCode })
          }))
        })
      }
    }

    // ===== DESCRIZIONE ======
    if (onix3.CollateralDetail) {
      if (onix3.CollateralDetail.TextContent) {
        book.descrizione = onix3.CollateralDetail.TextContent.Text;
      }
    }

    // ===== DATA PUBBLICAZIONE =====
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.PublishingDate) {
        let wo = onix3.PublishingDetail.PublishingDate.find(o => o.PublishingDateRole == '11');
        book.dtpubblicazione = wo ? wo.Date : undefined;
      }
    }

    // ===== DATA RISTAMPA =====
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.PublishingDate) {
        let wo = onix3.PublishingDetail.PublishingDate.find(o => o.PublishingDateRole == '12');
        book.dtultimaristampa = wo ? wo.Date : undefined;
      }
    }

    // ===== PREZZO =====
    if (onix3.ProductSupply) {
      if (onix3.ProductSupply.SupplyDetail) {
        if (onix3.ProductSupply.SupplyDetail.Price) {
          book.prezzo = onix3.ProductSupply.SupplyDetail.Price.PriceAmount;
        }
      }
    }

    // ===== TAX (IVA) =====
    if (onix3.ProductSupply) {
      // console.log(onix3.ProductSupply)
      if (onix3.ProductSupply.SupplyDetail) {
        if (onix3.ProductSupply.SupplyDetail.Price) {
          // console.log(onix3.ProductSupply.SupplyDetail.Price)
          if (onix3.ProductSupply.SupplyDetail.Price.Tax) {
            switch (onix3.ProductSupply.SupplyDetail.Price.Tax.TaxRatePercent) {
              case '4':
                book.tax = new Onix({
                  value: '04'
                })
                break;
              case '10':
                book.tax = new Onix({
                  value: '10'
                })
                break;
              case '20':
              case '22':
                book.tax = new Onix({
                  value: '20'
                })
                break;
              case '0': {
                if (onix3.ProductSupply.SupplyDetail.Price.Tax.TaxRateCode == 'Z') {
                  book.tax = new Onix({
                    value: '65'
                  })
                }
                if (onix3.ProductSupply.SupplyDetail.Price.Tax.TaxRateCode == 'P') {
                  book.tax = new Onix({
                    value: 'NS'
                  })
                }
                break;
              }
            }
          }
        }
      }
    }

    // ===== STATO EDITORE =====
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.PublishingStatus) {
        book.statoeditore = new Onix({ value: onix3.PublishingDetail.PublishingStatus });
      }
    }

    // ===== STATO DISTRIBUTORE =====
    if (onix3.ProductSupply) {
      if (onix3.ProductSupply.SupplyDetail) {
        if (onix3.ProductSupply.SupplyDetail.ProductAvailability) {
          book.statodistributore = new Onix({ value: onix3.ProductSupply.SupplyDetail.ProductAvailability });
        }
      }
    }

    // ===== DATA FUORI CATALOGO =====
    if (onix3.PublishingDetail) {
      if (onix3.PublishingDetail.PublishingDate) {
        let wo = onix3.PublishingDetail.PublishingDate.find(o => o.PublishingDateRole == '13');
        book.dtfuoricatalogo = wo ? wo.Date : undefined;
      }
    }

    // ===== MISURE =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Measure) {
        let wa = onix3.DescriptiveDetail.Measure.find(o => o.MeasureType == '01');
        book.altezza = wa ? wa.Measurement : undefined;

        let wl = onix3.DescriptiveDetail.Measure.find(o => o.MeasureType == '02');
        book.larghezza = wl ? wl.Measurement : undefined;

        let ws = onix3.DescriptiveDetail.Measure.find(o => o.MeasureType == '03');
        book.spessore = ws ? ws.Measurement : undefined;

        let wp = onix3.DescriptiveDetail.Measure.find(o => o.MeasureType == '10');
        book.peso = wp ? wp.Measurement : undefined;
      }
    }

    // ===== FORMATO =====
    book.formato = o.formato;

    // ===== PAGINE / DIMENSIONE (Mb) =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Extent) {
        onix3.DescriptiveDetail.Extent.forEach(o => {
          switch (o.ExtentType) {
            case '00':
              book.pagnumaraba = o.ExtentValue;
              break;
            case '03':
              book.pagnumromana = o.ExtentValue;
              break;
            case '05':
              book.pagcomplessive = o.ExtentValue;
              break;
            case '22':
              book.filesize = o.ExtentValue;
              break;
          }
        })
      }
    }
    book.pagindici = o.pagindici;

    // =========== e-book ===========
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.ProductForm == 'ED') {

        // ===== tipo contenuto =====
        if (onix3.DescriptiveDetail.PrimaryContentType) {
          book.tipoContenuto1 = new Onix({
            value: onix3.DescriptiveDetail.PrimaryContentType
          })
        }
        if (onix3.DescriptiveDetail.ProductContentType) {
          book.tipoContenuto2 = new Onix({
            value: onix3.DescriptiveDetail.ProductContentType
          })
        }
        // ===== protezione =====
        if (onix3.DescriptiveDetail.EpubTechnicalProtection) {
          book.protezione = new Onix({
            value: onix3.DescriptiveDetail.EpubTechnicalProtection
          })
        }

        // ===== distributore digitale =====
        if (onix3.ProductSupply) {
          if (onix3.ProductSupply.SupplyDetail) {
            if (onix3.ProductSupply.SupplyDetail.Supplier) {
              if (onix3.ProductSupply.SupplyDetail.Supplier.SupplierIdentifier) {
                book.distributoreDigitale = new Distributore({
                  codice: onix3.ProductSupply.SupplyDetail.Supplier.SupplierIdentifier.IDValue,
                  descrizione: onix3.ProductSupply.SupplyDetail.Supplier.SupplierName
                })
              }
            }
          }
        }
      }
    }

    // ===== confezione =====
    if (o.confezione) {
      book.confezione = new Onix({
        value: o.confezione.codice,
        etichetta: o.confezione.descrizione
      })
    }
    book.numinconfezione = o.numinconfezione

    // ===== collana =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Collection) {
        let wc = onix3.DescriptiveDetail.Collection.find(o => o.CollectionType == '10');
        if (wc) {
          if (wc.CollectionSequence && wc.CollectionSequence.CollectionSequenceNumber == 1) {
            if (wc.CollectionIdentifier) {
              let wci = wc.CollectionIdentifier.find(o => o.IDTypeName == 'EDB');
              if (wci) {
                book.collana = new Collana({
                  codice: wci.IDValue
                })
              }
            }
            if (wc.TitleDetail) {
              if (wc.TitleDetail.TitleType == '01' && wc.TitleDetail.TitleElement) {
                let te02 = wc.TitleDetail.TitleElement.find(o => o.TitleElementLevel == '02');
                if (te02) {
                  book.collanaEDBnum = +te02.PartNumber;
                }
                let te03 = wc.TitleDetail.TitleElement.find(o => o.TitleElementLevel == '03');
                if (te03) {
                  book.collanaEDBsezione = te03.TitleText;
                  book.collanaEDBnumsezione = +te03.PartNumber;
                }
              }
            }
          }
        }
      }
    }

    // ===== argomenti =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Subject) {
        onix3.DescriptiveDetail.Subject.forEach(s => {
          if (s.SubjectSchemeIdentifier == '23') {
            book.argomenti.push(new Argomento({
              codice: s.SubjectCode,
              descrizione: s.SubjectHeadingText
            }))
          }
        })
      }
    }


    // ===== destinatari =====
    // { "onix3.DescriptiveDetail.Audience": { "$elemMatch":  {"AudienceCodeType" : "02" } } }
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Audience) {
        onix3.DescriptiveDetail.Audience.forEach(o => {
          if (o.AudienceCodeType == '02') {
            book.destinatari.push(new Onix({ value: o.AudienceCodeValue }))
          }
        })
      }
    }

    // ===== note atti convegno =====
    // "Conference" : {
    //             "ConferenceName" : "Un secolo di vita italiana. Il contributo dei cattolici",
    //             "ConferenceNumber" : NumberInt(2),
    //             "ConferencePlace" : "Pistoia - Pisa",
    //             "ConferenceSponsor" : {
    //                 "CorporateName" : "Comitato Scientifico e Organizzatore delle Settimane Sociali dei Cattolici Italiani"
    //             },
    //             "ConferenceDate" : ISODate("2007-10-17T22:00:00.000+0000")
    //         },
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Conference) {
        book.conferenceName = onix3.DescriptiveDetail.Conference.ConferenceName;
        if (onix3.DescriptiveDetail.Conference.ConferenceNumber) {
          book.conferenceNumber = +onix3.DescriptiveDetail.Conference.ConferenceNumber;
        }
        book.conferenceDate = onix3.DescriptiveDetail.Conference.ConferenceDate;
        book.conferencePlace = onix3.DescriptiveDetail.Conference.ConferencePlace;
        if (onix3.DescriptiveDetail.Conference.ConferenceSponsor) {
          book.conferenceSponsorName = onix3.DescriptiveDetail.Conference.ConferenceSponsor.CorporateName;
        }
      }
    }

    // ===== DEWEY ======
    book.dewey_level1 = new Dewey({
      liv01: o.catalogazione_dewey_liv01 ? o.catalogazione_dewey_liv01 : '000',
      liv02: '000',
      liv03: '000',
      liv04: '000'
    })
    book.dewey_level2 = new Dewey({
      liv01: o.catalogazione_dewey_liv01 ? o.catalogazione_dewey_liv01 : '000',
      liv02: o.catalogazione_dewey_liv02 ? o.catalogazione_dewey_liv02 : '000',
      liv03: '000',
      liv04: '000'
    })
    book.dewey_level3 = new Dewey({
      liv01: o.catalogazione_dewey_liv01 ? o.catalogazione_dewey_liv01 : '000',
      liv02: o.catalogazione_dewey_liv02 ? o.catalogazione_dewey_liv02 : '000',
      liv03: o.catalogazione_dewey_liv03 ? o.catalogazione_dewey_liv03 : '000',
      liv04: '000'
    })
    book.dewey_level4 = new Dewey({
      liv01: o.catalogazione_dewey_liv01 ? o.catalogazione_dewey_liv01 : '000',
      liv02: o.catalogazione_dewey_liv02 ? o.catalogazione_dewey_liv02 : '000',
      liv03: o.catalogazione_dewey_liv03 ? o.catalogazione_dewey_liv03 : '000',
      liv04: o.catalogazione_dewey_liv04 ? o.catalogazione_dewey_liv04 : '000',
    })
    book.dewey_descrizione = o.catalogazione_dewey;

    // ===== BISAC (subject) =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Subject) {
        onix3.DescriptiveDetail.Subject.forEach(b => {
          if (b.SubjectSchemeIdentifier == '10') {
            book.bisac.push(new Bisac({
              codice: b.SubjectCode,
              descrizione: b.SubjectHeadingText
            }))
          }
        })
      }
    }

    // ===== CCE (subject) =====
    if (onix3.DescriptiveDetail) {
      if (onix3.DescriptiveDetail.Subject) {
        onix3.DescriptiveDetail.Subject.forEach(c => {
          if (c.SubjectSchemeIdentifier == '53') {
            book.cce.push(new Cce({
              codice: c.SubjectCode,
              descrizione: c.SubjectHeadingText
            }))
          }
        })
      }
    }

    // ===== CATALOGAZIONE ======
    if (o.catalogazione) {
      o.catalogazione.forEach(c => {
        if (c) {
          book.catalogazione.push(
            new Catalogazione({
              codice: c.codice,
              label: c.label,
              parent: c.parent
            }))
        }
      })
    }

    // ===== servizio stampa ======
    if (o.servizioStampa) {
      o.servizioStampa.forEach(c => {
        if (c) {
          book.servizioStampa.push(new ServizioStampa({
            titolo: c.titolo,
            testo: this.html2txt(c.testo),
            testoFormattato: c.testoFormattato,
            tipo: c.tipo,
            portale: c.portale
          }))
        }
      })
    }

    book.exportCEC = o.exportCEC;
    book.exportedCEC = o.exportedCEC;
    book.exportableCEC = o.exportableCEC;
    book.updatedDate = o.updatedDate;

    book.numColoriStampa = o.numColoriStampa;
    book.tavoleGrafiche = o.tavoleGrafiche;

    // ===== status log (pushPrezziEStatiEdiwin) ======
    // console.log(o.statusLog)
    if (o.statusLog) {
      o.statusLog.forEach(wsl => {
        book.statusLog.push(
          new StatusLog({
            date: wsl.date,
            publishingDetail: wsl.publishingDetail,
            productAvailability: wsl.productAvailability,
            priceAmount: wsl.priceAmount
          })
        )
      })
    }

    return book;
  }

  toMongo(book: Book) {
    let onix3: any = {};
    onix3.ProductIdentifier = [];

    onix3.DescriptiveDetail = {};
    onix3.DescriptiveDetail.Contributor = [];
    onix3.DescriptiveDetail.TitleDetail = [];
    onix3.DescriptiveDetail.Collection = [];
    onix3.DescriptiveDetail.Language = [];
    onix3.DescriptiveDetail.Measure = [];
    onix3.DescriptiveDetail.Extent = [];
    onix3.DescriptiveDetail.Subject = [];
    onix3.DescriptiveDetail.Audience = [];
    onix3.DescriptiveDetail.ReligiousText = {};
    onix3.DescriptiveDetail.ReligiousText.ReligiousTextFeature = [];

    onix3.PublishingDetail = {};
    onix3.PublishingDetail.Publisher = [];
    onix3.PublishingDetail.PublishingDate = [];

    onix3.RelatedMaterial = {};
    onix3.RelatedMaterial.RelatedProduct = [];

    onix3.CollateralDetail = {};
    onix3.CollateralDetail.TextContent = {};

    onix3.ProductSupply = {};
    onix3.ProductSupply.SupplyDetail = {};
    onix3.ProductSupply.SupplyDetail.Price = {};

    let confezione: any;

    let catalogazione = [];

    let servizioStampa = [];

    // ===== EAN-13 ======
    if (book.ean13) {
      onix3.ProductIdentifier.push({
        ProductIDType: '03',
        IDValue: book.ean13
      })
    }

    // ===== CONTRIBUTORS ======
    if (book.contributor) {
      book.contributor.forEach(c => {
        if (c) {
          console.log('toMongo', c.ruolo)
          onix3.DescriptiveDetail.Contributor.push({
            ContributorRole: c.ruolo ? c.ruolo.value : undefined,
            NameIdentifier: {
              NameIDType: "01",
              IDValue: c.codice
            },
            NameType: "04",
            PersonName: c.nomecompleto,
            NamesBeforeKey: c.nome,
            KeyNames: c.cognome
          })
        }
      })
    }

    // ===== EDITORE ======
    if (book.editore) {
      onix3.PublishingDetail.Publisher.push({
        PublishingRole: '01',
        PublisherIdentifier: {
          PublisherIDType: '01',
          IDTypeName: 'RL',
          IDValue: book.editore.codice
        },
        PublisherName: book.editore.descrizione,
        Website: book.websiteLink ? {
          WebsiteRole: '02',
          WebsiteLink: book.websiteLink //'http://www.dehoniane.it/control/dettagliolibro?ean13=' + book.ean13
        } : null
      })
    }

    // ===== CO-EDITORE ======
    if (book.coeditore) {
      onix3.PublishingDetail.Publisher.push({
        PublishingRole: '02',
        PublisherIdentifier: {
          PublisherIDType: '01',
          IDTypeName: 'RL',
          IDValue: book.coeditore.codice
        },
        PublisherName: book.coeditore.descrizione
      })
    }

    // ===== MARCHIO EDITORIALE ======
    if (book.marchio) {
      onix3.PublishingDetail.Imprint = {
        ImprintIdentifier: {
          ImprintIDType: '01',
          IDTypeName: 'RL',
          IDValue: book.marchio.codice
        },
        ImprintName: book.marchio.descrizione
      }
    }

    // ===== LUOGO DI PUBBLICAZIONE ======
    if (book.cityOfPublication) {
      onix3.PublishingDetail.CityOfPublication = book.cityOfPublication;
    }

    // ===== TITOLO  ======
    if (book.prefisso || book.titolo || book.sottotitolo) {
      onix3.DescriptiveDetail.TitleDetail.push(book.prefisso ? {
        TitleType: '01',
        TitleElement: {
          TitleElementLevel: '01',
          TitlePrefix: book.prefisso,
          TitleWithoutPrefix: book.titolo,
          Subtitle: book.sottotitolo
        }
      } : {
          TitleType: '01',
          TitleElement: {
            TitleElementLevel: '01',
            TitleText: book.titolo,
            Subtitle: book.sottotitolo
          }
        })
    }

    if (book.titolooriginale) {
      // {"onix3.DescriptiveDetail.TitleDetail" : { $elemMatch: {  TitleType: '03'} } }
      onix3.DescriptiveDetail.TitleDetail.push({
        TitleType: '03',
        TitleElement: {
          TitleElementLevel: '01',
          TitleText: book.titolooriginale,
        }
      })
    }

    if (book.titolobreve) {
      // {"onix3.DescriptiveDetail.TitleDetail" : { $elemMatch: {  TitleType: '05'} } }
      onix3.DescriptiveDetail.TitleDetail.push({
        TitleType: '05',
        TitleElement: {
          TitleElementLevel: '01',
          TitleText: book.titolobreve,
        }
      })
    }

    if (book.insiemetitolo || book.insiemeparte || book.sottoinsiemetitolo || book.sottoinsiemeparte) {
      let wte = [];
      if (book.insiemetitolo || book.insiemeparte) {
        wte.push({
          TitleElementLevel: '02',
          TitleText: book.insiemetitolo,
          PartNumber: +book.insiemeparte
        })
      }
      if (book.sottoinsiemetitolo || book.sottoinsiemeparte) {
        wte.push({
          TitleElementLevel: '03',
          TitleText: book.sottoinsiemetitolo,
          PartNumber: +book.sottoinsiemeparte
        })
      }
      onix3.DescriptiveDetail.Collection.push({
        CollectionType: '00',
        TitleDetail: {
          TitleType: '01',
          TitleElement: wte
        }
      })
    }

    // ===== TIPO EDIZIONE ======
    if (book.edizione) {
      onix3.DescriptiveDetail.EditionType = book.edizione.value;
    }

    // ===== NUMERO EDIZIONE ======
    if (book.numedizione) {
      onix3.DescriptiveDetail.EditionNumber = book.numedizione;
    }

    // ===== NUMERO RISTAMPA ======
    if (book.numristampa) {
      onix3.PublishingDetail.LatestReprintNumber = book.numristampa;
    }

    // ===== COLLEGAMENTO ALTRE OPERE =====
    if (book.relatedProducts) {
      book.relatedProducts.forEach(o => {
        onix3.RelatedMaterial.RelatedProduct.push({
          ProductRelationCode: o.tipologia ? o.tipologia.value : undefined,
          ProductIdentifier: {
            ProductIDType: '03',
            IDValue: o.ean13
          }
        })
      })
    }

    // ===== TIPO PRODOTTO =====
    if (book.tipoProdotto) {
      onix3.DescriptiveDetail.ProductForm = book.tipoProdotto.value;
    }

    // ===== TIPO PRODOTTO DETTAGLIO =====
    if (book.tipoProdottoDettaglio) {
      onix3.DescriptiveDetail.ProductFormDetail = book.tipoProdottoDettaglio.value;
    }

    // ===== STAGIONALITA =====
    if (book.stagionalita) {
      book.stagionalita.forEach(o => {
        onix3.DescriptiveDetail.ReligiousText.ReligiousTextFeature.push({
          ReligiousTextFeatureType: '01',
          ReligiousTextFeatureCode: o.value
        })
      })
    }

    // ===== LINGUE =====
    if (book.lingue) {
      book.lingue.forEach(o => {
        onix3.DescriptiveDetail.Language.push({
          LanguageRole: o.tipologia ? o.tipologia.value : undefined,
          LanguageCode: o.lingua ? o.lingua.value : undefined
        })
      })
    }

    // ===== DESCRIZIONE ======
    if (book.descrizione) {
      onix3.CollateralDetail.TextContent.Text = book.descrizione;
    }

    // ===== DATA PUBBLICAZIONE =====
    if (book.dtpubblicazione) {
      onix3.PublishingDetail.PublishingDate.push({
        PublishingDateRole: '11',
        Date: book.dtpubblicazione
      })
    }

    // ===== DATA RISTAMPA =====
    if (book.dtultimaristampa) {
      onix3.PublishingDetail.PublishingDate.push({
        PublishingDateRole: '12',
        Date: book.dtultimaristampa
      })
    }

    // ===== PREZZO =====
    if (book.prezzo) {
      onix3.ProductSupply.SupplyDetail.Price.PriceType = '02';
      onix3.ProductSupply.SupplyDetail.Price.PriceAmount = book.prezzo;
      onix3.ProductSupply.SupplyDetail.Price.CurrencyCode = 'EUR';
    }

    // ===== TAX (IVA) =====
    if (book.tax) {
      switch (book.tax.value) {
        case '04': {
          onix3.ProductSupply.SupplyDetail.Price.Tax = {
            "TaxType": "01",
            "TaxRateCode": "S",
            "TaxRatePercent": "4"
          }
          break;
        }
        case '10': {
          onix3.ProductSupply.SupplyDetail.Price.Tax = {
            "TaxType": "01",
            "TaxRateCode": "S",
            "TaxRatePercent": "10"
          }
          break;
        }
        case '20': {
          onix3.ProductSupply.SupplyDetail.Price.Tax = {
            "TaxType": "01",
            "TaxRateCode": "S",
            "TaxRatePercent": "22"
          }
          break;
        }
        case '65': {
          onix3.ProductSupply.SupplyDetail.Price.Tax = {
            "TaxType": "01",
            "TaxRateCode": "Z",
            "TaxRatePercent": "0"
          }
          break;
        }
        case 'NS': {
          onix3.ProductSupply.SupplyDetail.Price.Tax = {
            "TaxType": "01",
            "TaxRateCode": "P",
            "TaxRatePercent": "0"
          }
          break;
        }
      }
    }

    // ===== STATO EDITORE =====
    if (book.statoeditore) {
      onix3.PublishingDetail.PublishingStatus = book.statoeditore.value;
    }

    // ===== STATO DISTRIBUTORE =====
    if (book.statodistributore) {
      onix3.ProductSupply.SupplyDetail.ProductAvailability = book.statodistributore.value;
    }

    // ===== DATA FUORI CATALOGO =====
    if (book.dtfuoricatalogo) {
      onix3.PublishingDetail.PublishingDate.push({
        PublishingDateRole: '13',
        Date: book.dtfuoricatalogo
      })
    }

    // ===== MISURE =====
    if (book.altezza) {
      onix3.DescriptiveDetail.Measure.push({
        MeasureType: '01',
        Measurement: book.altezza,
        MeasureUnitCode: "mm"
      })
    }
    if (book.larghezza) {
      onix3.DescriptiveDetail.Measure.push({
        MeasureType: '02',
        Measurement: book.larghezza,
        MeasureUnitCode: "mm"
      })
    }
    if (book.spessore) {
      onix3.DescriptiveDetail.Measure.push({
        MeasureType: '03',
        Measurement: book.spessore,
        MeasureUnitCode: "mm"
      })
    }
    if (book.peso) {
      onix3.DescriptiveDetail.Measure.push({
        MeasureType: '10',
        Measurement: book.peso,
        MeasureUnitCode: "gr"
      })
    }

    // ===== PAGINE / DIMENSIONE (Mb) =====
    if (book.pagnumaraba) {
      onix3.DescriptiveDetail.Extent.push({
        ExtentType: '00',
        ExtentValue: book.pagnumaraba,
        ExtentUnit: '03'
      })
    }
    if (book.pagnumromana) {
      onix3.DescriptiveDetail.Extent.push({
        ExtentType: '03',
        ExtentValue: book.pagnumromana,
        ExtentUnit: '03'
      })
    }
    if (book.pagcomplessive) {
      onix3.DescriptiveDetail.Extent.push({
        ExtentType: '05',
        ExtentValue: book.pagcomplessive,
        ExtentUnit: '03'
      })
    }
    if (book.filesize) {
      onix3.DescriptiveDetail.Extent.push({
        ExtentType: '22',
        ExtentValue: book.filesize,
        ExtentUnit: '19' //Mb
      })
    }


    // =========== e-book ===========
    if (book.tipoContenuto1) {
      onix3.DescriptiveDetail.PrimaryContentType = book.tipoContenuto1.value;
    }
    if (book.tipoContenuto2) {
      onix3.DescriptiveDetail.ProductContentType = book.tipoContenuto2.value;
    }
    if (book.protezione) {
      onix3.DescriptiveDetail.EpubTechnicalProtection = book.protezione.value;
    }
    if (book.distributoreDigitale) {
      onix3.ProductSupply.SupplyDetail.Supplier = {
        SupplierIdentifier: {
          IDValue: book.distributoreDigitale.codice,
          SupplierIDType: '01',
          IDTypeName: 'DD'
        },
        SupplierName: book.distributoreDigitale.descrizione,
        SupplierRole: '00'
      }
    }



    // ===== confezione =====
    if (book.confezione) {
      confezione = {
        codice: book.confezione.value,
        descrizione: book.confezione.etichetta,
      }
    }

    // ===== collana =====
    if (book.collana) {
      // console.log('book.collanaEDBsezione', book.collanaEDBsezione, book.collanaEDBnumsezione)

      let _titleDetail = function() {
        let wo = {
          TitleType: '01',
          TitleElement: []
        }
        // collanaEDBnum: number;
        // collanaEDBsezione: string;
        // collanaEDBnumsezione: number;
        if (book.collanaEDBnum) {
          wo.TitleElement.push({
            TitleElementLevel: '02',
            PartNumber: book.collanaEDBnum,
            TitleText: book.collana.descrizione
          })
        }
        if (book.collanaEDBsezione) {
          wo.TitleElement.push({
            TitleElementLevel: '03',
            PartNumber: book.collanaEDBnumsezione,
            TitleText: book.collanaEDBsezione
          })
        }
        return wo;
      }
      onix3.DescriptiveDetail.Collection.push({
        CollectionType: '10',
        CollectionIdentifier: [
          {
            CollectionIDType: '01',
            IDTypeName: 'RL',
            IDValue: book.collana.codiceCEC
          },
          {
            CollectionIDType: '01',
            IDTypeName: 'EDB',
            IDValue: book.collana.codice
          }
        ],
        CollectionSequence: {
          CollectionSequenceType: '01',
          CollectionSequenceTypeName: 'EDB',
          CollectionSequenceNumber: 1
        },
        TitleDetail: _titleDetail()
      })
    }

    // ===== argomenti =====
    if (book.argomenti) {
      book.argomenti.forEach(a => {
        onix3.DescriptiveDetail.Subject.push({
          SubjectSchemeIdentifier: '23',
          SubjectCode: a.codice,
          SubjectHeadingText: a.descrizione
        })
      })
    }

    // ===== dewey (subject) =====
    // {
    //  "SubjectSchemeIdentifier": "01",
    //  "SubjectSchemeVersion": "21",
    //  "SubjectCode": "265.5",
    //  "SubjectHeadingText": "SACRAMENTI. MATRIMONIO"
    // }
    if (book.dewey_descrizione) {
      // 265.5 (ed. 21) - SACRAMENTI. MATRIMONIO
      let wdeweytkns = book.dewey_descrizione.split('-');
      if (wdeweytkns.length == 2 && wdeweytkns[0].indexOf('(') > 0) {
        let wcode = wdeweytkns[0].substring(0, wdeweytkns[0].indexOf('('));
        let wheading = wdeweytkns[1];
        onix3.DescriptiveDetail.Subject.push({
          SubjectSchemeIdentifier: '01',
          SubjectSchemeVersion: '21',
          SubjectCode: wcode.trim(),
          SubjectHeadingText: wheading.trim()
        })
      }
    }

    // ===== BISAC (subject) =====
    if (book.bisac) {
      book.bisac.forEach(bisac => {
        onix3.DescriptiveDetail.Subject.push({
          SubjectSchemeIdentifier: '10',
          SubjectCode: bisac.codice,
          SubjectHeadingText: bisac.descrizione
        })
      })
    }

    // ===== CCE (subject) =====
    if (book.cce) {
      book.cce.forEach(cce => {
        onix3.DescriptiveDetail.Subject.push({
          SubjectSchemeIdentifier: '53',
          SubjectCode: cce.codice,
          SubjectHeadingText: cce.descrizione
        })
      })
    }

    // ===== destinatari =====
    // { "onix3.DescriptiveDetail.Audience": { "$elemMatch":  {"AudienceCodeType" : "02" } } }
    if (book.destinatari) {
      book.destinatari.forEach(d => {
        onix3.DescriptiveDetail.Audience.push({
          AudienceCodeType: '02',
          AudienceCodeTypeName: 'RL',
          AudienceCodeValue: d.value
        })
      })
    }

    // ===== note atti convegno =====
    // "Conference" : {
    //             "ConferenceName" : "Un secolo di vita italiana. Il contributo dei cattolici",
    //             "ConferenceNumber" : NumberInt(2),
    //             "ConferencePlace" : "Pistoia - Pisa",
    //             "ConferenceSponsor" : {
    //                 "CorporateName" : "Comitato Scientifico e Organizzatore delle Settimane Sociali dei Cattolici Italiani"
    //             },
    //             "ConferenceDate" : ISODate("2007-10-17T22:00:00.000+0000")
    //         },

    // conferenceName: string;
    // conferenceSponsorName: string;
    // conferenceNumber: number;
    // conferenceDate: Date;
    // conferencePlace: string;
    if (book.conferenceName) {
      onix3.DescriptiveDetail.Conference = {
        ConferenceName: book.conferenceName,
        ConferenceNumber: book.conferenceNumber,
        ConferenceDate: book.conferenceDate,
        ConferencePlace: book.conferencePlace
      }
      if (book.conferenceSponsorName) {
        onix3.DescriptiveDetail.Conference.ConferenceSponsor = {
          CorporateName: book.conferenceSponsorName
        }
      }
    }

    // ===== CATALOGAZIONE ======
    if (book.catalogazione) {
      book.catalogazione.forEach(c => {
        if (c) {
          catalogazione.push(
            new Catalogazione({
              codice: c.codice,
              label: c.label,
              parent: c.parent
            }))
        }
      })
    }


    // ===== servizio stampa ======
    if (book.servizioStampa) {
      book.servizioStampa.forEach(c => {
        if (c) {
          servizioStampa.push(
            new ServizioStampa({
              titolo: c.titolo,
              testo: this.html2txt(c.testo),
              testoFormattato: c.testoFormattato,
              tipo: c.tipo,
              portale: c.portale
            })
          )
        }
      })
    }


    if (book.idtitolo) {
      onix3.RecordReference = 'CEDCatalog.onix301.' + book.idtitolo;
      onix3.ProductIdentifier.push({
        ProductIDType: '01',
        IDTypeName: 'EDB ID',
        IDValue: book.idtitolo
      })
    }
    onix3.NotificationType = '01';



    return {
      ean13: book.ean13,
      sottotitolo2: book.sottotitolo2,
      titoloEDB: book.titoloEDB,
      catalogazione_dewey: book.dewey_descrizione,
      catalogazione_dewey_liv01: book.dewey_level1 && book.dewey_level1.liv01 ? book.dewey_level1.liv01 : '000',
      catalogazione_dewey_liv02: book.dewey_level2 && book.dewey_level2.liv02 ? book.dewey_level2.liv02 : '000',
      catalogazione_dewey_liv03: book.dewey_level3 && book.dewey_level3.liv03 ? book.dewey_level3.liv03 : '000',
      catalogazione_dewey_liv04: book.dewey_level4 && book.dewey_level4.liv04 ? book.dewey_level4.liv04 : '000',
      numColoriStampa: book.numColoriStampa,
      tavoleGrafiche: book.tavoleGrafiche,
      autoriabbreviato: book.autoriabbreviato,
      autoriabbreviatoedb: book.autoriabbreviatoedb,
      autoriportale: book.autoriportale,
      numinconfezione: book.numinconfezione,
      confezione: confezione,
      taxCodeCEC: book.taxCodeCEC,
      exportCEC: book.exportCEC,
      exportableCEC: book.exportableCEC,
      visibilitaPortaleCED: book.visibilitaPortaleCED,
      homeNovita: book.homeNovita,
      lockuser: book.lockuser,
      lockdate: book.lockdate,
      inevidenza: book.inevidenza,
      pompaindice: book.pompaindice,
      note: book.note,
      NumUltimaRistampaEDB: book.NumUltimaRistampaEDB,
      titolodetailEDB: book.titolodetailEDB,
      titolodetailCEC: book.titolodetailCEC,

      visibile: book.visibile ? book.visibile : false,

      carrellabile: book.carrellabile ? book.carrellabile : false,

      notecommento: book.notecommento,
      catalogoRow: book.catalogoRow,
      catalogazione: catalogazione,

      formato: book.formato,

      pagindici: book.pagindici,

      servizioStampa: book.servizioStampa,

      // dtpubblicazione: book.dtpubblicazione,
      dtpubblicazione: book.dtpubblicazione ? moment(book.dtpubblicazione).startOf('day').format('YYYY-MM-DD HH:mm:ss') : undefined,

      onix3: onix3
    }
  }

  checkEan(eanCode: string): boolean {
    if (eanCode) {
      const VALIDCHARS = "0123456789";
      for (let i = 0; i < eanCode.length; i++) {
        let digit = eanCode.charAt(i);
        if (VALIDCHARS.indexOf(digit) == -1) {
          return false;
        }
      }

      // Check for 13 digits otherwise
      if (eanCode.length != 13) {
        return false;
      }

      // Get the check number
      let originalCheck = eanCode.substring(eanCode.length - 1);
      eanCode = eanCode.substring(0, eanCode.length - 1);

      // Add even numbers together
      let even = Number(eanCode.charAt(1)) +
        Number(eanCode.charAt(3)) +
        Number(eanCode.charAt(5)) +
        Number(eanCode.charAt(7)) +
        Number(eanCode.charAt(9)) +
        Number(eanCode.charAt(11));
      // Multiply this result by 3
      even *= 3;

      // Add odd numbers together
      let odd = Number(eanCode.charAt(0)) +
        Number(eanCode.charAt(2)) +
        Number(eanCode.charAt(4)) +
        Number(eanCode.charAt(6)) +
        Number(eanCode.charAt(8)) +
        Number(eanCode.charAt(10));

      // Add two totals together
      let total = even + odd;

      // Calculate the checksum
      // Divide total by 10 and store the remainder
      let checksum = total % 10;
      // If result is not 0 then take away 10
      if (checksum != 0) {
        checksum = 10 - checksum;
      }

      // Return the result
      if (checksum != Number(originalCheck)) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  uploadCarpetta(fileToUpload: any) {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    let input = new FormData();
    input.append("file", fileToUpload);
    console.log('bookService == uploadCarpetta', fileToUpload);
    let options = new RequestOptions({ responseType: ResponseContentType.Json });
    return this.http.post(environment.server.url + '/book/bookFromCarpetta', input, options)
      .map(response => response.json())
  }

  bookFromGoogleSheet(ean13: any, worksheetTitle: any) {
    return this.http.post(environment.server.url + '/book/bookFromGoogleSheet', { ean13: ean13, worksheetTitle: worksheetTitle })
      .map(response => response.json())
      .catch(this.handleError)
  }

  bookFromGoogleSheetEvo(ean13: any, worksheetTitle: any) {
    return this.http.post(environment.server.url + '/book/bookFromGoogleSheetEvo', { ean13: ean13, worksheetTitle: worksheetTitle })
      .map(response => response.json())
      .catch(this.handleError)
  }

  private handleError(error: Response | any) {
    console.error(error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/book.service.ts